
<div class="" v-if="dataDescription != null">
    <div class="accordion" role="tablist">
        <b-card no-body class="mb-1" v-if="dataDescription.bolsa_destinada" v-b-toggle.accordion-1>
            <b-card-header header-tag="header" class="p-1" role="tab">
                <h6 @click="setCurrentTab('accordion-1')" class="header-tab">
                    <!-- <img src="https://prestaprendacali-16905.kxcdn.com/public-assets/arrow-right" class="faq-arrow"> --> Bolsa destinada
                </h6>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="accordion-tabs" role="tabpanel">
                <b-card-body>
                    <div class="text-wrapper-card mb-1" v-html="dataDescription.bolsa_destinada">
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-card no-body class="mb-1" v-if="dataDescription.promocion_requisitos" v-b-toggle.accordion-2>
            <b-card-header header-tag="header" class="p-1" role="tab">
                <h6 @click="setCurrentTab('accordion-2')" class="header-tab" >
                    <!-- <img src="https://prestaprendacali-16905.kxcdn.com/public-assets/arrow-right" class="faq-arrow"> --> Requisitos
                </h6>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="accordion-tabs" role="tabpanel">
                <b-card-body>
                    <div class="text-wrapper-card mb-1" v-html="dataDescription.promocion_requisitos"></div>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-card no-body class="mb-1" v-if="dataDescription.condiciones_y_mecanica" v-b-toggle.accordion-3>
            <b-card-header header-tag="header" class="p-1" role="tab">
                <h6 @click="setCurrentTab('accordion-3')" class="header-tab">
                    <!-- <img src="https://prestaprendacali-16905.kxcdn.com/public-assets/arrow-right" class="faq-arrow"> --> Condiciones y mecánica
                </h6>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="accordion-tabs" role="tabpanel">
              <b-card-body>
                    <div class="text-wrapper-card mb-1" v-html="dataDescription.condiciones_y_mecanica">
                    </div>
              </b-card-body>
            </b-collapse>
        </b-card>
        <b-card no-body class="mb-1" v-if="dataDescription.promocion_restricciones_n" v-b-toggle.accordion-4>
            <b-card-header header-tag="header" class="p-1" role="tab">
                <h6 @click="setCurrentTab('accordion-4')" class="header-tab">
                    <!-- <img src="https://prestaprendacali-16905.kxcdn.com/public-assets/arrow-right" class="faq-arrow"> --> Restricciones
                </h6>
            </b-card-header>
            <b-collapse id="accordion-4" accordion="accordion-tabs" role="tabpanel">
              <b-card-body>
                    <div class="text-wrapper-card mb-1" v-html="dataDescription.promocion_restricciones_n">
                    </div>
              </b-card-body>
            </b-collapse>
        </b-card>
         <b-card no-body class="mb-1" v-if="dataDescription.promocion_legales_f" v-b-toggle.accordion-5>
            <b-card-header header-tag="header" class="p-1" role="tab">
                <h6 @click="setCurrentTab('accordion-5')" class="header-tab">
                    <!-- <img src="https://prestaprendacali-16905.kxcdn.com/public-assets/arrow-right" class="faq-arrow"> --> Legales
                </h6>
            </b-card-header>
            <b-collapse id="accordion-5" accordion="accordion-tabs" role="tabpanel">
                <b-card-body>
                    <div class="text-wrapper-card mb-1" v-html="dataDescription.promocion_legales_f">
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</div>
